import React, { Suspense } from "react"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import Bugsnag from "../layout/bugsnag"
import { BrowserRouter as Router } from "react-router-dom"
import { UserProvider } from "hooks/use-current-user"
import { PromoCodeProvider } from "hooks/use-promo-code"
import { initialize, configure } from "react-rb"
import request from "react-rb/request"
import { FormConfig } from "@kit/design/use-form"
import { Features } from "core/features"
import { queryClient } from "core/query-client"
import { loadPageComponent } from "bundler/load-page-component"

const submit = async (url, options) => {
  const { data } = await request(url, options)
  return data
}

function Layout({ children }) {
  // Toggle menu display on React pages
  React.useEffect(() => {
    const btn = document.querySelector('[data-target="#main-navbar"]')
    const menu = document.getElementById("main-navbar")

    const toggleMenu = () => {
      menu.classList.toggle("collapse")
    }
    btn && btn.addEventListener("click", toggleMenu)

    return () => {
      btn && btn.removeEventListener("click", toggleMenu)
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <Bugsnag>
        <Features>
          <UserProvider>
            <PromoCodeProvider>
              <FormConfig request={submit}>
                <Router>
                  <Suspense fallback={<div />}>{children}</Suspense>
                </Router>
              </FormConfig>
            </PromoCodeProvider>
          </UserProvider>
        </Features>
      </Bugsnag>
    </QueryClientProvider>
  )
}

function setup() {
  initialize({ layout: Layout })
  configure({ loadPageComponent })
}

if (document.readyState === "complete") {
  setup()
} else {
  document.addEventListener("DOMContentLoaded", setup)
}
